module.exports = __webpack_public_path__ + "static/media/money3.2c63727b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/money3.png
// module id = 665
// module chunks = 0 1